import {createContext, useState} from "react";

export const AboutContext = createContext();
export const AboutProvider = ({children}) => {
    const [showAbout, setShowAbout] = useState(false);

    const toggleAboutModal = () => {
        setShowAbout(!showAbout);
    };

    return (
        <AboutContext.Provider value={{showAbout, toggleAboutModal}}>
            {children}
        </AboutContext.Provider>
    );
}
export const About = ({onClose}) => {
    return (
        <div className="fixed z-50 inset-0 overflow-y-auto">
            <div className="flex items-center justify-center min-h-screen">
                <div className="fixed inset-0 bg-gray-500 opacity-75"></div>
                <div className="bg-white rounded-md overflow-hidden shadow-xl transform transition-all max-w-screen-lg w-1/2 sm:mt-10 mt-5">
                <button className="absolute top-0 right-0 mr-4" onClick={onClose}>
                <span aria-hidden="true" style={{fontSize: '40px', fontWeight: 'bold', fontHeight: 1, color: '#d1d1d1'}}>×</span>
                </button>
                    <div className="p-10">
                    <h1 className="text-4xl font-bold">About this air quality compliance map</h1>
                        <p className="mb-5">This interactive tool allows users to explore air quality data that makes up
                            the UK's annual air quality compliance assessment against the Air Quality Standards Regulations (2010).</p>
                        <p className="mb-5">Users can view and download compliance data by zone and agglomeration or by
                            Local Authority. The UK is assessed against different limit values (LV), target values (TV),
                            long term objectives (LTO) and critical levels (CL) for various pollutants, more about these
                            limits and objectives <a href="https://uk-air.defra.gov.uk/air-pollution/uk-eu-limits"
                                                     className="text-blue-500 hover:text-blue-700 underline">here</a>.
                        </p>
                        <p className="mb-5">UK level data can be downloaded using the Air Quality Compliance Data Hub <a
                            href="https://compliance-data.defra.gov.uk/"
                            className="text-blue-500 hover:text-blue-700 underline">here</a>. </p>
                        <p className="mb-5">Our annual compliance assessment report can be found <a
                            href="https://uk-air.defra.gov.uk/library/annualreport/"
                            className="text-blue-500 hover:text-blue-700 underline">here</a>.</p>
                        <p className="mb-5">Licencing information can be viewed <a
                            href="https://uk-air.defra.gov.uk/data/gis-licences"
                            className="text-blue-500 hover:text-blue-700 underline">here</a>.</p>
                        <p className="mb-5">The 2021 NO<sub>x</sub> and NO<sub>2</sub> data in this map, originally published on 29th September 2022, has
                            been republished on the 8th of February 2024. The re-publication corrected a processing error which caused an underestimate in
                            the NO<sub>x</sub> emissions from taxis in central London.</p>
                        <h1 className="text-4xl font-bold">Compliance regions</h1>
                        <p className="mb-5">Users can select either one zone and agglomeration (zone) or one Local
                            Authority.</p>
                        <p className="mb-5">The UK is divided into 43 zones for air quality assessment where each zone
                            is an area of land defined specifically for air quality compliance reporting purposes, more
                            about zones <a href="https://uk-air.defra.gov.uk/air-pollution/"
                                           className="text-blue-500 hover:text-blue-700 underline">here</a>.</p>
                        <p className="mb-5">Local Authorities instead are the governing body of a county or district,
                            the number of Local Authorities may vary between years.</p>
                        <h1 className="text-4xl font-bold">Pollutant metrics</h1>
                        <p className="mb-5">There are 21 pollutant metrics to choose from, covering those stated in the
                            Air Quality Standards Regulations.</p>
                        <div className="px-10 mb-5">

                            <ul className="list-disc list-outside">
                                <li>
                                    Fixed measurements - Measurements from UK AIR quality monitoring networks including
                                    Defra's Automatic Urban Rural Network (AURN). Note that fixed monitoring stations in
                                    the national networks used for the compliance assessment are distributed according
                                    to air quality zones and some Local Authorities will not include these measurements
                                    points.
                                </li>
                                <li>
                                    Supplementary measurements – Measurements from the UK Urban NO2 Network. A diffusion
                                    tube network (only visible in some locations when Nitrogen Dioxide annual mean is
                                    selected).
                                </li>
                                <li>
                                    Modelled Roadside Concentrations - Roadside concentrations modelled by Defra's
                                    Pollution Climate Mapping Models.
                                </li>
                                <li>
                                    Modelled Background Concentrations - 1x1km background concentrations modelled by
                                    Defra's Pollution Climate Mapping Models.
                                    Individual data sets for each of the data sources that make up the compliance
                                    assessment are also available, however availability of each is dependent on what
                                    metric is selected.
                                </li>
                            </ul>
                        </div>

                        <h1 className="text-4xl font-bold">Need help using this tool?</h1>
                        <p className="mb-5">For any questions about this tool, please contact <a href="mailto:"
                                                                                                 className="text-blue-500 hover:text-blue-700 underline">aqinfo@ricardo.com</a>.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};